import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import type { StorageUnit } from 'store/storageunits/types';
import { ResponseParseError } from '../apiErrors';
import { toApiQueryError } from '../apiQueryError';
import type { ApiQueryError } from '../apiQueryError';
import { getProjects } from './cloudsaveApi';
import { withOwnerCheck } from './withOwnerCheck';

export const cloudsaveQueryApi = createApi({
  reducerPath: 'cloudsaveApi',
  baseQuery: fakeBaseQuery<ApiQueryError>(),
  keepUnusedDataFor: 60,
  tagTypes: ['StorageLists'],
  endpoints: (builder) => ({
    getProjects: builder.query<StorageUnit[], string | null>({
      providesTags: ['StorageLists'],
      async queryFn(ownerId, { signal }) {
        try {
          const response = await withOwnerCheck(ownerId, () =>
            getProjects(signal),
          );
          if (!Array.isArray(response.parsedBody))
            throw new ResponseParseError('Expected a storage unit list');
          return {
            data: response.parsedBody
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name)),
          };
        } catch (error) {
          return { error: toApiQueryError(error) };
        }
      },
    }),
  }),
});
export const { useGetProjectsQuery } = cloudsaveQueryApi;
